var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrientation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 52,
    viewBox: "0 0 59 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6575 23.1194C37.9157 21.5289 38.6669 19.5188 38.6669 17.3333C38.6669 12.1787 34.4882 8 29.3336 8C24.1789 8 20.0002 12.1787 20.0002 17.3333C20.0002 19.5188 20.7514 21.5289 22.0097 23.1194C17.694 25.3772 14.6669 29.5885 14.6669 34.6667C14.6669 36.1394 15.8608 37.3333 17.3336 37.3333C18.8063 37.3333 20.0002 36.1394 20.0002 34.6667C20.0002 30.535 23.8749 26.6667 29.3336 26.6667C34.7922 26.6667 38.6669 30.535 38.6669 34.6667C38.6669 36.1394 39.8608 37.3333 41.3336 37.3333C42.8063 37.3333 44.0002 36.1394 44.0002 34.6667C44.0002 29.5885 40.9731 25.3772 36.6575 23.1194ZM29.3336 13.3333C27.1244 13.3333 25.3336 15.1242 25.3336 17.3333C25.3336 19.5425 27.1244 21.3333 29.3336 21.3333C31.5427 21.3333 33.3336 19.5425 33.3336 17.3333C33.3336 15.1242 31.5427 13.3333 29.3336 13.3333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000244141 2.66667C0.000244141 1.19391 1.19415 0 2.66691 0H56.0002C57.473 0 58.6669 1.19391 58.6669 2.66667V42.6667C58.6669 44.1394 57.473 45.3333 56.0002 45.3333H37.1048L31.2192 51.219C30.1778 52.2604 28.4894 52.2604 27.448 51.219L21.5623 45.3333H2.66691C1.19415 45.3333 0.000244141 44.1394 0.000244141 42.6667V2.66667ZM5.33358 5.33333V40H22.6669C23.3742 40 24.0524 40.281 24.5525 40.7811L29.3336 45.5621L34.1146 40.7811C34.6147 40.281 35.293 40 36.0002 40H53.3336V5.33333H5.33358Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrientation);
export default __webpack_public_path__ + "static/media/orientation.d717b77367d5ce42a9e6f024d19d6722.svg";
export { ForwardRef as ReactComponent };